export const install = (component, alias) => {
    const comp = component;
    comp.install = (app) => {
        app.component(comp.name, comp);
        if (alias)
            app.config.globalProperties[alias] = comp;
    };
    return comp;
};
